<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Liver Specific Details EMR Preview
    </template>
    <template #body>
      <b> {{ liverPeldList?.length ?? 0 }} Measurement{{ liverPeldList?.length > 1 ? 's' : '' }} found </b> 
      <br><br>
      <div class="sections">
        <div v-if="!liverPeldList || !liverPeldList?.length">
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Serum Bilirubin"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                disabled
                label="INR"
              />
            </div>
          </div>
    
        
   
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Growth Failure"
              />
            </div> 

            <div class="col-2">
              <ADSTextInput
                disabled
                label="Serum Albumin"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="generalComments"
                disabled
                label="General Comments"
              />
            </div> 
          </div>

          <div class="row">
            <div class="col-4 pediatricConditions">
              <ADSTextInput
                v-model="pediatricConditions"
                disabled
                label="Pediatric Conditions"
              />
            </div>
          </div>
        </div>
        <div
          v-for="( item ) in liverPeldList"
          :key="item"
        >
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                v-model="item.testdate"
                disabled
                label="Test Date"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="item.SerumBilirubin"
                disabled
                label="Serum Bilirubin"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="item.inr"
                disabled
                label="INR"
              />
            </div>
          </div>
    
        
   
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                v-model="growthFailure"
                disabled
                label="Growth Failure"
              />
            </div> 

            <!-- <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div> -->
         

            <div class="col-2">
              <ADSTextInput
                v-model="item.SerumAlbumin"
                disabled
                label="Serum Albumin"
              />
            </div>

            <div class="col-2">
              <ADSTextInput
                v-model="generalComments"
                disabled
                label="General Comments"
              />
            </div> 
          </div>

          <div class="row">
            <div class="col-4 pediatricConditions">
              <ADSTextInput
                v-model="pediatricConditions"
                disabled
                label="Pediatric Conditions"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-4 pediatricConditions">
              <ADSTextInput
                v-model="exceptionDiseases"
                disabled
                label="Exception Diseases"
              />
            </div>
          </div>
          <hr class="lineBreak">
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "LiverSpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      testDate: this.getTestDate( this.patientBundle ),
     // serumCreatinine: this.getSerumCreatinine( this.patientBundle ),
      inr: this.getINR( this.patientBundle ), 
      serumAlbumin: this.getSerumAlbumin( this.patientBundle ),
      serumBilirubin: this.getSerumBilirubin( this.patientBundle ),
      growthFailure: this.getGrowthFailure( this.patientBundle ),
      pediatricConditions: this.getPediatricConditions( this.patientBundle ),
      exceptionDiseases: this.getExceptionDiseases( this.patientBundle ),
      generalComments: this.getGeneralComments( this.patientBundle ),
      liverPeldList: this.getLiverPeldList( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const components = match[0].resource?.component;
      if( !components?.length ) {
        return null;
      }
      const values = components
        .map( ( n ) => _.get( n, valuePath ) )
        .filter( ( v ) => v !== null && v !== undefined )
        .map( ( v ) => String( v ) );
      if( !values.length ) {
        return null;
      }
      return values.join( ', ' );
    },
    getLiverPeldList( patientBundle ) {
      const fields = [
        { observationCode: 'SK#8076', valuePath: 'valueDateTime', propertyName: 'testdate' },
        { observationCode: 'SK#8078', valuePath: 'valueString', propertyName: 'inr' },
        { observationCode: 'SK#8079', valuePath: 'valueString', propertyName: 'SerumAlbumin' },
        { observationCode: 'SK#8077', valuePath: 'valueString', propertyName: 'SerumBilirubin' },
      ];
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const valueLists = fields.map( ( field ) => {
        const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === field.observationCode );
        const components = match[0]?.resource?.component;
        if( !components?.length ) {
          return [];
        }
        return components.map( ( n ) => {
          const value = _.get( n, field.valuePath );
          if( value === null || value === undefined ) {
            return null;
          }
          return String( value );
        } );
      } );
      const length = Math.max( 0, ...valueLists.map( ( list ) => list.length ) );
      if( !length ) {
        return null;
      }
      const liverPeldList = [];
      for( let index = 0; index < length; index++ ) {
        const entry = {};
        let hasValue = false;
        fields.forEach( ( field, fieldIndex ) => {
          const value = valueLists[ fieldIndex ][ index ] ?? null;
          entry[ field.propertyName ] = value;
          if( value !== null ) {
            hasValue = true;
          }
        } );
        if( hasValue ) {
          liverPeldList.push( entry );
        }
      }
      if( !liverPeldList.length ) {
        return null;
      }
      console.log( 'liverPeldList', liverPeldList );
      return liverPeldList;
    },
    getTestDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8076', 'valueDateTime' );
    },
    // getSerumCreatinine( patientBundle ) {
    //   return this.getSmartdataComponentValue( patientBundle, 'SK#8060' );
    // },
    getINR( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8078', ); 
    },
    getSerumAlbumin( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8079' );
    },
    getSerumBilirubin( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8077' );
    },
    getGrowthFailure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8080', 'valueBoolean' );
    },
    getPediatricConditions( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8081' );
    },
    getExceptionDiseases( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8485' );
    },
    getGeneralComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8082' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 650px;
  width: 1400px;
  overflow: scroll;
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.pediatricConditions .afflo-ds-form-control) {
  width: 800px;
} 

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

.lineBreak {
  /* color: black;
  height: 2px; */
  background-color: rgb(59, 53, 53);
  border: 0 none;
    /* color: black; */
  height: 5px;
}

</style>
